import React, { ReactNode } from 'react';

import Card from '@/src/components/common/Elements/Card/Card';
import { cn } from '@/src/util/ui';

type EntryCardProps = {
  children: ReactNode;
  cardRef?: React.RefObject<HTMLDivElement>;
  onClick?: (event: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement>) => void;
  className?: string;
  isActive?: boolean;
};

const EntryCard = ({
  children,
  cardRef,
  className,
  isActive = null,
  onClick = null,
}: EntryCardProps) => {
  // Active use the pseudo element style

  return (
    <Card
      cardRef={cardRef}
      className={cn(
        'tw-border-[1px] tw-border-solid ',
        isActive && 'tw-border-cfo-blue-400 tw-shadow-[1px_2px_4px_0px_rgba(80,129,255,0.20)]',
        !isActive && 'tw-border-cfo-grey-500',
        className
      )}
      onClick={onClick}
    >
      {children}
    </Card>
  );
};

export default EntryCard;
